import apiFactory from '../apiFatory';

export default apiFactory(
  'User',
  [

  ]
);
